import { useImage } from "./useImage"
import { useRoutes } from "./useRoutes"

const useCarouselImages = (carousel?: GatsbyTypes.SanityCarousel, legacyImage = true) => {
  const { getResponsiveImage, getResponsiveImages } = useImage()
  const { urlResolver } = useRoutes()

  const images = carousel
    ? carousel.images?.map(item => ({
        ...item,
        key: item?._key,
        image: legacyImage ? getResponsiveImage(item?.image) : getResponsiveImages(item?.image),
        link: urlResolver(item?.link),
      }))
    : []

  return images
}

export default useCarouselImages
